import { render } from "./AddAccountOrUserToProject.vue?vue&type=template&id=55fc94a9&scoped=true"
import script from "./AddAccountOrUserToProject.vue?vue&type=script&lang=js"
export * from "./AddAccountOrUserToProject.vue?vue&type=script&lang=js"

import "./AddAccountOrUserToProject.vue?vue&type=style&index=0&id=55fc94a9&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55fc94a9"]])

export default __exports__